// extracted by mini-css-extract-plugin
export var pageList = "ContentfulBlockDetailList-module--pageList--MM7tu";